module.exports = __webpack_public_path__ + "img/01.4687cb02.png";